import { Component, Input, OnInit, ViewChild, TemplateRef, HostListener, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UnsavedChangingsService } from '@shared/services/unsaved-changings.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { StringsService } from '@shared/services/strings.service';
import { AppService } from '@shared/services/app.service';
import { environment } from '../../../../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-unsaved-changes',
  templateUrl: './unsaved-changes.component.html',
  styleUrls: ['./unsaved-changes.component.scss'],
})
export class UnsavedChangesComponent implements OnInit {
  @Input() fromComponent: boolean;
  @Output() emitResult = new EventEmitter<boolean>();
  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;

  // @Input() leavePageEvent$!: Observable<null>;

  constructor(
    public dialog: MatDialog,
    private appService: AppService,
    private unsavedChangingsService: UnsavedChangingsService,
    public stringsService: StringsService,
  ) {}

  ngOnInit(): void {
    if (this.fromComponent) {
      setTimeout(() => {
        this.openDialog();
      },0)
    } else {
      this.unsavedChangingsService.leavePageWithChangesTrigger$.pipe(untilDestroyed(this)).subscribe({
        next: () => this.openDialog(),
      });
    }
  }

  private openDialog() {
    const dialogRef = this.dialog.open(this.dialogTemplate);
    dialogRef
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (data) => {
          if (this.fromComponent) {
            this.emitResult.emit(data);
            return
          }
          this.unsavedChangingsService.userAnswerResult$.next(data);
          // this.unsavedChangingsService.markComponentAsSaved();
        },
      });
  }

  @HostListener('window:beforeunload', ['$event'])
  preventLeaveUnsavedPage(event: any) {
    if (!environment.production) {
      return null;
    }
    if (!this.unsavedChangingsService.isFormSaved()) {
      event.preventDefault();
      return (event.returnValue = 'Are you sure you want to exit?');
    } else {
      return null;
    }
  }
}
